import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useStoreFileViewerContext } from "../../hooks/context";
import ShareObject from "../ShareObject";
import { Stack } from "@mui/material";
import CreateSharesButton from "../CreateNewShareButton/CreateSharesButton";
var StoreFileSharing = function (_a) {
    var object = _a.object;
    var _b = useStoreFileViewerContext(), apiRef = _b.apiRef, updated = _b.updated;
    var _c = useState([]), shares = _c[0], setShares = _c[1];
    useEffect(function () {
        handleFetchShares();
    }, [object.id, updated]);
    var handleFetchShares = function () {
        var _a;
        if (!object.id || !((_a = apiRef.share) === null || _a === void 0 ? void 0 : _a.list))
            return;
        // FIXME: Share list needs filtering
        apiRef.share.list({}).then(function (response) {
            var _a;
            if (response.status === "Success" &&
                !!response.result.share_link_objects) {
                setShares((_a = response.result.share_link_objects) === null || _a === void 0 ? void 0 : _a.filter(function (link) { var _a; return !!link && ((_a = link.targets) === null || _a === void 0 ? void 0 : _a.includes(object.id)); }));
            }
            else {
                setShares([]);
            }
        });
    };
    var handleDeleteShare = function () {
        handleFetchShares();
    };
    return (_jsxs(_Fragment, { children: [!!(object === null || object === void 0 ? void 0 : object.id) && (_jsxs(Stack, { direction: "row", gap: 1, children: [_jsx(CreateSharesButton, { shareType: "email", object: object, ButtonProps: {
                            variant: "contained",
                            color: "primary",
                            sx: { width: "100%" },
                            fullWidth: true,
                        }, onClose: function () { }, onDone: function () {
                            return;
                        } }), _jsx(CreateSharesButton, { shareType: "link", object: object, ButtonProps: {
                            variant: "contained",
                            color: "primary",
                            sx: { width: "100%" },
                            fullWidth: true,
                            children: "Get Link",
                        }, onClose: function () { }, onDone: function () {
                            return;
                        } })] })), _jsx(Stack, { spacing: 1, paddingTop: 1, children: shares.map(function (share) {
                    return (_jsx(ShareObject, { object: share, onDelete: handleDeleteShare }, "share-object-".concat(share.id)));
                }) })] }));
};
export default StoreFileSharing;
